// import type { OperationKey } from "@/types/plagiarism";
import { DomainName } from "./constant";

//const currentEnv = `${import.meta.env.REACT_APP_ENVIRONMENT}`;
const currentEnv = import.meta.env.VITE_ENVIRONMENT || "DEVELOPMENT";

//console.log("app config current-react-environment::", `${import.meta.env.REACT_APP_ENVIRONMENT}`);
console.log("app config current-vite-environment::", `${import.meta.env.VITE_ENVIRONMENT}`);

//  const currentReactEnv = `${import.meta.env.REACT_APP_ENVIRONMENT}`;
//  console.log(" config current-react-environment::", currentReactEnv);

// const currentVITEEnv = `${import.meta.env.VITE_ENVIRONMENT}`;
// console.log("config current-vite-environment::", currentVITEEnv);

/** Max GET jobstatus attempts for music generation (5s interval → ~5 min). */
export const jobCounter = 60;

/** Max GET jobstatus attempts for stem separation (5s interval → ~10 min). */
export const stemJobCounter = 240;

export const pollingIntervalInMilliSeconds = 5000;

export const getServiceToken = () => {
  const serviceToken: any = {
    QA: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
    PRODUCTION:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiYTAxZmQ4YzEtZGNkYS00NzNiLTg1Y2ItZWNhNzA5OGY1YjY5Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiOWM3ZDk3NjYtOWViZi00N2E0LTk0ZTYtM2YxZjUwY2Q0YjJmIiwibmJmIjoxNzI4NjM4MjU2LCJleHAiOjIwNDQyMTQyNTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.f-EANyK8sM4V9keqN54Y7qZmVgkj7I_yG7N-VaFa8CsQWPYBTNe39Tj0tYAInch84TlBMGIPLUV0CRworzDvG9l8eS0XkEJ5tqCQpXFuO62ahOj814LmsdOzLn8Euw2jyy0pVrLT2mpv-FlRzK6n1SeqY-uhftp9SSkWHQ91QJI9VLUZE3_sOpf73A1-4RUPneekOEFyfLkouMjEkkcvScnkX5IsjG9VD3N-7dZSOd_gnBGSaFOKNWyFu6A2uoYP3eyK86b9wMKifhszATyWXI2ltD9eTtq9GRt48oEePIRmS0Q8l5j39h1rA_-4W7lbN1YajyYprKG3cEUlHTXwCA",
    STAGING:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI2NzM5MWEyMWVlMDU0NzJhYjEzM2NkNzA4ZWM4MDQ4ZiJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiYTAxZmQ4YzEtZGNkYS00NzNiLTg1Y2ItZWNhNzA5OGY1YjY5Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiOWM3ZDk3NjYtOWViZi00N2E0LTk0ZTYtM2YxZjUwY2Q0YjJmIiwibmJmIjoxNzI4NjM4MjU2LCJleHAiOjIwNDQyMTQyNTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.f-EANyK8sM4V9keqN54Y7qZmVgkj7I_yG7N-VaFa8CsQWPYBTNe39Tj0tYAInch84TlBMGIPLUV0CRworzDvG9l8eS0XkEJ5tqCQpXFuO62ahOj814LmsdOzLn8Euw2jyy0pVrLT2mpv-FlRzK6n1SeqY-uhftp9SSkWHQ91QJI9VLUZE3_sOpf73A1-4RUPneekOEFyfLkouMjEkkcvScnkX5IsjG9VD3N-7dZSOd_gnBGSaFOKNWyFu6A2uoYP3eyK86b9wMKifhszATyWXI2ltD9eTtq9GRt48oEePIRmS0Q8l5j39h1rA_-4W7lbN1YajyYprKG3cEUlHTXwCA",
    DEVELOPMENT:
      "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsInRva2VuX3R5cGUiOjIwLCJraWQiOiI0NGUwZmY2MzgwY2E0YzhkOWFlNzBjMjExMjc5NGFiNyJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9zaWQiOiIwMDAwMDAwMC0wMDAwLTAwMDAtMDAwMC0wMDAwMDAwMDAwMDAiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL2dyb3Vwc2lkIjoiN2ZjOWY0MjUtMTQ2My00YThlLTg1NTYtNmM2YjM0Y2ZjZmY2Iiwic2NvcGUiOiJmdWxsYWNjZXNzIiwidGVuYW50X2dyb3VwX2lkIjoiNTgwYzhiNWEtZGI4My00ODM0LTE0ZWYtMDhkOTUwMWU3MzVkIiwibmJmIjoxNzI4NTUzMDk2LCJleHAiOjIwNDQxMjkwOTYsImlzcyI6IkxlZ2FsU2ltcGxpIiwiYXVkIjoiUERGU2ltcGxpIn0.KameEF9JU4__i_tmeiJQprFIpc0gGoNrXE4ti-ZqCqAhT2UflZL6NCz-herJ3pZfRTGUfsvR8n5-kPZeALbv1F_JY3sjEN4k5m-D2r4L2XjnpS7nNTznc2K5SImmounTp5F3kscXTz-qdQMInE3FjDD6U0Dbl8VPCFQR9e1XzS3_cegwTa3-tqcM7bJAsGkC17EQMec-loQiv55FISd_L8_Wq2dt3QbCnEYsR7WBMs2YWuHf2A3JVrhpr99CxRQZDVWvCDpetw9xqEvLKoViTNVKyfeN823KE26uHmRv52geyUJDnpWDCjoezFxQVWl4ODWNag8Wtw74Rx44nyl4pw",
  };
  return serviceToken[currentEnv];
};

export const getBlobUri = () => {
  const BlobUri: any = {
    PRODUCTION: "https://prodlegalsimplistorage.blob.core.windows.net/",
    STAGING: "https://prodlegalsimplistorage.blob.core.windows.net/",
    QA: "https://devlegalsimpli.blob.core.windows.net/",
    DEVELOPMENT: "https://devlegalsimpli.blob.core.windows.net/",
  };

  return BlobUri[currentEnv];
};

export const blobSignature = () => {
  const blobSign: any = {
    QA: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
    PRODUCTION: "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    STAGING: "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    DEVELOPMENT: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
  };
  return blobSign[currentEnv];
};

export const sasTokenExpiryHours = 48;

export const base64ToByteArray = (base64: any) => {
  const binaryString = atob(base64);

  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }

  return byteArray;
};
export const currentDomain = () => {
  //let subdomain = "";
  let domainName = DomainName.PDFSIMPLI;
  const currentUrl = window.location.hostname;
  if (currentUrl.indexOf("signsimpli") > -1) {
    domainName = DomainName.SIGNSIMPLI;
  } else if (currentUrl.indexOf("legalsimpli") > -1) {
    domainName = DomainName.LEGALSIMPLI;
  } else if (currentUrl.indexOf("pdfsimpli") > -1 || currentUrl.includes("localhost")) {
    domainName = DomainName.PDFSIMPLI;
  } else if (currentUrl.indexOf("resumebuild") > -1) {
    domainName = DomainName.RESUMEBUILD;
  } else if (currentUrl.indexOf("worksimpli") > -1) {
    domainName = DomainName.WORKSIMPLI;
  }
  return domainName;
};
export const getInitializationVector = () => {
  const ivKey: any = {
    QA: "2908290630030702",
    PRODUCTION: "2908290630030702",
    STAGING: "2908290630030702",
    DEVELOPMENT: "2908290630030702",
  };
  return ivKey[currentEnv];
};

export const getTenantId = () => {
  let tenantId: any = {};
  let domain = currentDomain();
  switch (domain?.toLowerCase()) {
    case DomainName.RESUMEBUILD:
      tenantId = {
        QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
        PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
      };
      break;
    case DomainName.SIGNSIMPLI:
      tenantId = {
        QA: "7135E969-7E6B-4B40-978A-59B3C34BC2A7",
        PRODUCTION: "A7F6040A-9299-4DB7-9307-4C2A572D2956",
        STAGING: "A7F6040A-9299-4DB7-9307-4C2A572D2956",
        DEVELOPMENT: "7135E969-7E6B-4B40-978A-59B3C34BC2A7",
      };
      break;
    case DomainName.LEGALSIMPLI:
      tenantId = {
        QA: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
        PRODUCTION: "0F10199F-52CD-488D-B949-F3DCBD34070F",
        STAGING: "0F10199F-52CD-488D-B949-F3DCBD34070F",
        DEVELOPMENT: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
      };
      break;
    case DomainName.PDFSIMPLI:
      tenantId = {
        QA: "98504B3A-612F-4A9E-9426-B6FA98A054D6",
        PRODUCTION: "5F01FFC9-54E3-4BA3-9F50-B61EF634521B",
        STAGING: "5F01FFC9-54E3-4BA3-9F50-B61EF634521B",
        DEVELOPMENT: "98504B3A-612F-4A9E-9426-B6FA98A054D6",
      };
      break;
    case DomainName.WORKSIMPLI:
      tenantId = {
        QA: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        PRODUCTION: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        STAGING: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
        DEVELOPMENT: "1BAE83A3-BFAA-4C89-99B1-6DD2130E2F55",
      };
      break;
    default:
      tenantId = {
        QA: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
        PRODUCTION: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        STAGING: "F583361C-4EE9-485C-9CBC-2F83DE7020C1",
        DEVELOPMENT: "7fc9f425-1463-4a8e-8556-6c6b34cfcff6",
      };
      break;
  }
  return tenantId[currentEnv];
};

export const thumbnailStripMaxLimit = () => {
  const maxLimit: any = {
    QA: 160,
    PRODUCTION: 160,
    STAGING: 160,
    DEVELOPMENT: 160,
  };
  return maxLimit[currentEnv];
};
type Env = "QA" | "PRODUCTION" | "STAGING" | "DEVELOPMENT";

const currentEnvs = (import.meta.env.VITE_ENVIRONMENT as Env) || "DEVELOPMENT";

export const FilesBlobPath = (): string => {
  const fileBlobPath: Record<Env, string> = {
    QA: "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers",
    PRODUCTION: "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers",
    STAGING: "https://prodlegalsimplistorage.blob.core.windows.net/pdfsimpliusers",
    DEVELOPMENT: "https://devlegalsimpli.blob.core.windows.net/pdfsimpliusers",
  };

  // Optional runtime check
  if (!(currentEnvs in fileBlobPath)) {
    throw new Error(`Invalid environment: ${currentEnvs}`);
  }

  return fileBlobPath[currentEnvs];
};
export const chatSupportPath = () => {
  const chatUrl: Record<Env, string> = {
    QA: "https://static-bw-qa.worksimpli.io/chatsimpli-resources/scripts/injectorCode.js",
    PRODUCTION: "https://static-bw.worksimpli.io/chatsimpli-resources/prod/scripts/injectorCode.js",
    STAGING: "https://static-bw.worksimpli.io/chatsimpli-resources/stg/scripts/injectorCode.js",
    DEVELOPMENT: "https://static-bw-qa.worksimpli.io/chatsimpli-resources/scripts/injectorCode.js"
  };
  return chatUrl[currentEnvs];
};

export const getStaticAssetBaseUrl = () => {
  const staticAssetBaseUrl: Record<Env, string> = {
    QA: "https://static-bw-qa.worksimpli.io",
    PRODUCTION: "https://static-bw.worksimpli.io",
    STAGING: "https://static-bw.worksimpli.io",
    DEVELOPMENT: "https://static-bw-qa.worksimpli.io",
  };
  return staticAssetBaseUrl[currentEnvs];
};

export const getAudioCdnBlobPath = (): string => {
  return `${getStaticAssetBaseUrl()}/audio/songs`;
};

export const buildSampleSongUrl = (genre: string, filename: string): string => {
  const base = getAudioCdnBlobPath();
  return `${base}/${genre}/${filename}`;
};

export const getSongBackgroundCdnBlobPath = (): string => {
  return `${getStaticAssetBaseUrl()}/assets/images/music-backgrounds`;
};

export const buildOccasionBackgroundUrl = (occasionSlug: string): string => {
  return `${getSongBackgroundCdnBlobPath()}/occasions/${occasionSlug}.jpg`;
};

export const buildGenreBackgroundUrl = (genreSlug: string): string => {
  return `${getSongBackgroundCdnBlobPath()}/genres/${genreSlug}.jpg`;
};

export const buildDefaultSongBackgroundUrl = (): string => {
  return `${getSongBackgroundCdnBlobPath()}/default.jpg`;
};
